import React from 'react';
import styled, { StylesProps } from '../../../../../lib/styles';

import sponsorBlockStyles from './SponsorBlock_styles';
import Typography from '../../../../../components/presentational/Typography';
import Image from '../../../../../components/presentational/Image';

interface Sponsor {
  title: string;
  imageURL: string;
  href: string;
}

export interface SponsorBlockData {
  type: 'sponsor_block';
  title?: string;
  sponsors: Sponsor[];
}

export interface SponsorBlockProps {
  block: SponsorBlockData;
}

const SponsorBlock = ({
  block: { title, sponsors },
  styles,
}: SponsorBlockProps & StylesProps<typeof sponsorBlockStyles>) => (
  <div className={styles.panel}>
    <div className={styles.container}>
      <Typography>
        <h3>{title}</h3>
      </Typography>

      <div className={styles.sponsors}>
        {sponsors.map(({ title, imageURL, href }) => (
          <a key={title} href={href} title={title} target={'_blank'}>
            <Image
              lazy
              src={imageURL}
              alt={title}
              height={70}
              resizeHeight={70}
              resizeFit={'min'}
            />
          </a>
        ))}
      </div>
    </div>
  </div>
);

export default styled(sponsorBlockStyles)(SponsorBlock);
